import { render, staticRenderFns } from "./ToggleKeyboard.vue?vue&type=template&id=c932bfd4&scoped=true&"
import script from "./ToggleKeyboard.vue?vue&type=script&lang=js&"
export * from "./ToggleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./ToggleKeyboard.vue?vue&type=style&index=0&id=c932bfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c932bfd4",
  null
  
)

export default component.exports